import { ReactComponent as Icon } from '../../assets/icons/hubjectContracts.svg';

export default function () {
  return <Icon className="MuiSvgIcon-root" alt="Hubject" aria-label="Hubject" />;
}
